export default "/images/0ace76bf1ee831af94e46c1be5618ccc.avif";